<template>
  <div :class="$style.record">
    <header>
      <i :class="`iconfont yw-xiangzuo ${$style.back}`" @click="back"></i>
      <p>免责声明</p>
    </header>
    <div>
      <p>1.用户应当自行确认提现账户的准确性，我方平台向用户绑定的微信账号发放红包视为我方支付完毕，因用户绑定错误导致的责任和损失，由用户自行承担。</p>
      <p>2.用户不得以任何不正当手段或舞弊方式获取红包金额，不正当手段及舞弊行为包括但不限于：利用多台手机设备注册多个账号；篡改设备数据；使用插件、外挂、系统或第三方工具；恶意牟利等扰乱平台秩序以及本平台认为的其他不正当手段。</p>
      <p>3. 如果用户以任何不正当手段或舞弊方式参与红包活动，本平台有权采取限制登录、封停账号、撤销活动资格、限制提现、账号金额清零、限制再次注册等措施，因此造成的用户损失，由用户承担全部责任。</p>
      <p>4.如用户已完成以违规行为所取得的金额提现，本平台有权追回该部分金额，用户应当在收到通知后的三日内将金额返还到指定账户，本平台保留追究该用户责任的权利。</p>
      <p>5.本平台有权对活动规则进行变更或调整。相关变动或调整以本平台官方发布的为准，并于公布时生效，用户继续参与该活动则视为对前述变动或调整后的规则予以同意。</p>
      <p>6.为保证用户顺利提现，用户应当按提示规则规范操作，如用户未按提现要求操作等导致不能收款(如未在微信公众号绑定游戏账号等）本平台不进行任何赔偿或补偿。</p>
      <p>7.因不可抗力、相关政策活动调整等原因导致本次活动调整、暂停取消或终止活动的，本平台无需为此承担任何法律责任。</p>
      <p>8.因第三方行为包括但不限于第三方利用各种不正当手段攻击、篡改、对活动进行干扰、破坏、修改或施加其他影响或系统故障导致红包发放、提现等发生错误、用户无法参与或参与失败的，本平台无需为此承担任何法律责任。</p>
      <p>9.因用户自身操作不当或用户所在地区网络故障、支付平台网络故障、电信运营商故障、第三方其他平台限制等非本平台所能控制的原因导致的用户无法参与活动或参与失败，本平台无需为此承担任何法律责任。</p>
      <p>10.本平台保留在法律规定的范围内对本活动及本协议解释的权利。</p>
    </div>
  </div>
</template>

<script>

export default {
  name: '',
  data () {
    return {
      recordList: []
    };
  },
  mounted() {
  },
  methods: {
    back() {
      this.$emit('close');
    },
  }
}
</script>

<style lang="scss" module>
$font-lg: 15px;
$font-nm: 12px;
$font-sm: 9px;

.record {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background: #ffffff;
  overflow: auto;
  box-sizing: border-box;
  &::-webkit-scrollbar {
    display: none;
  }
  > header {
    position: relative;
    font-size: $font-lg;
    color: #424242;
    text-align: center;
    margin-bottom: 30px;
    padding: 12px 0 24px;
    background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/red-envelope/v2/condition_back.png');
    background-size: 100% 100%;
    color: #FFFFFF;
    > .back {
      position: absolute;
      left: 0;
      font-size: $font-lg;
      box-sizing: content-box;
      padding: 5px { top: 0; left: 0 };
    }
  }
  > div {
    padding: 0 10px 10px;
    p {
      font-size: 12px;
      line-height: 18px;
      margin-bottom: 2px;
    }
  }
}
</style>  